import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import HeaderComponent from "../../Componentes/Header/Header.component";
import FooterComponent from "../../Componentes/Footer/Footer.component";
import OpcionesComponent from "../../Componentes/Opciones/Opciones.component";
import * as ClasificacionActions from "../../../Core/Actions/Clasificacion.action";
import * as LoginActions from "./../../../Core/Actions/Login.actions";
import "./Layout.page.scss";

const Layout = ({
  children,
  clasificacionReducer,
  obtenerClasificaciones,
  loginReducer,
  consumirCerrarSession,
}) => {
  const [clasificaciones, setClasificaciones] = useState([]);
  const [estiloLayout, setEstiloLayout] = useState("container");
  const [hayCliente, setHayCliente] = useState(false);
  const [productos, setProductos] = useState([]);
  let location = useLocation();

  useEffect(() => {
    const { Clasificaciones } = clasificacionReducer;

    if (Clasificaciones.length <= 0) {
      obtenerClasificaciones();
    }
  }, []);

  useEffect(() => {
    const { Clasificaciones } = clasificacionReducer;

    setClasificaciones(Clasificaciones);
  }, [clasificacionReducer]);

  useEffect(() => {
    const { hayCliente } = loginReducer;
    setHayCliente(hayCliente);
  }, [loginReducer.hayCliente]);

  useEffect(() => {
    const { datos } = loginReducer.Cliente;
    let Productos = [];

    if (datos) {
      const { PedidoActual } = datos;

      if (PedidoActual) {
        const { datos: datosPedido } = PedidoActual;
        if (datosPedido) {
          Productos = datosPedido?.Productos || [];
        }
      }
    }

    setProductos(Productos);
  }, [loginReducer.Cliente]);

  useEffect(() => {
    const { pathname } = location;
    if (pathname === "/") {
      setEstiloLayout("container");
    } else {
      setEstiloLayout("container");
    }
  }, [location]);

  return (
    <>
      <section id="Header">
        <HeaderComponent Clasificaciones={clasificaciones} />
        <div className="container-fluid">
          <OpcionesComponent
            hayCliente={hayCliente}
            cerrarSession={consumirCerrarSession}
            productos={productos}
          />
        </div>
      </section>
      <section id="Contenido">
        <div className={estiloLayout}>{children}</div>
      </section>
      <section id="Footer">
        <div className="container-fluid">
          <FooterComponent />
        </div>
      </section>
    </>
  );
};

const mapStateToProps = ({ clasificacionReducer, loginReducer }) => {
  return { clasificacionReducer, loginReducer };
};

const mapDispatchToProps = {
  ...ClasificacionActions,
  ...LoginActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
